//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import PPE_BASIC_02 from './PPE_BASIC_02';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import { useSearch1, useSave1 } from './PPE_BASIC_02_QUERY';
import dayjs from 'dayjs';
//#endregion


function PPE_BASIC_02F(props) {
  //#region 변수
  const [readyToExport, setReadyToExport] = useState(false);
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 파일 관련 변수
  const fileInputRef = useRef(null);
  const imgRef = useRef(null); //작성자 사인
  const [excelData, setExcelData] = useState([
    {
      EQUIP_NM: '보호구명',
      EQUIP_USE: '용도',
      IN_QTY: 0,
      STOCK_QTY: 0,
      USE_QTY: 0,
      CURR_QTY: 0,
      REMARK: '비고',
    },
  ]); //엑셀용 그리드 데이터

  //왼쪽 그리드
  const [originalRowData1, setOriginalRowData1] = useState([]); // 원본 데이터 (접기/펼치기 상태 포함)
  const [rowData1, setRowData1] = useState([]); // 보호구관리대장 그리드 데이터 (필터링된 표시용)
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 보호구관리대장 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 보호구관리대장 그리드 변경 시 데이터
  const gridRef1 = useRef(); // 보호구등록 그리드
  const gridRef2 = useRef(); // 엑셀업로드

  const isSearchingRef = useRef(false); // 무한 루프 방지용 플래그

  //#endregion

  useEffect(() => {
    // 현재 탭이 1번이 아닌 경우 처리하지 않음
    if (props.value !== 1) return;
    if (!props.searchClick2) return;

    ResetLogic1();

    const { custCd, depCd } = searchInfo;

    if (!custCd && !depCd) {
      props.setSearchClick2(false);
      return;
    }

    if (!props.validateSelection()) {
      props.setSearchClick2(false);
      return;
    }

    SearchLogic1();
    props.setSearchClick2(false);
  }, [props.value, props.searchClick2]);

  // 접힌 그룹의 하위 행 필터링 함수
  const filterExpandedRows = (data) => {
    if (!data || data.length === 0) return [];

    const filtered = [];
    let i = 0;

    while (i < data.length) {
      const row = data[i];

      // 그룹 행은 항상 추가
      if (row.isGroupRow) {
        filtered.push(row);
        i++;

        // 그룹이 펼쳐져 있으면 하위 행들도 추가
        if (row.isExpanded !== false) {
          // 같은 ER_CD를 가진 하위 행들을 찾아서 추가
          while (
            i < data.length &&
            !data[i].isGroupRow &&
            data[i].groupErCd === row.erCd
          ) {
            filtered.push(data[i]);
            i++;
          }
        } else {
          // 그룹이 접혀있으면 하위 행들을 건너뛰기
          while (
            i < data.length &&
            !data[i].isGroupRow &&
            data[i].groupErCd === row.erCd
          ) {
            i++;
          }
        }
      } else {
        // 그룹 행이 아닌 경우 (이론적으로는 발생하지 않아야 함)
        filtered.push(row);
        i++;
      }
    }

    return filtered;
  };

  //#region 조회
  // 관리대장 조회
  const { refetch: Search1 } = useSearch1({
    context: {
      search: {
        custCd: searchInfo.custCd || '',
        currentYear: searchInfo.year || dayjs().format('YYYY'),
        currentMonth: searchInfo.month || dayjs().format('MM'),
      },
    },
    onSuccess: (ledgerRows) => {
      // 관리대장 데이터를 보호구명과 보호구코드(erCd)별로 그룹화 (camelCase)
      const ledgerByGroup = new Map();
      ledgerRows?.forEach((item) => {
        const equipNm = item.equipNm || '';
        const erCd = item.erCd || '';
        if (!equipNm || !erCd) return;
        
        // 보호구명과 보호구코드를 조합한 키로 그룹화
        const groupKey = `${equipNm}_${erCd}`;
        if (!ledgerByGroup.has(groupKey)) {
          ledgerByGroup.set(groupKey, []);
        }
        ledgerByGroup.get(groupKey).push(item);
      });

      // 관리대장 데이터로부터 그룹 생성 (camelCase)
      const groupedData = [];
      ledgerByGroup.forEach((ledgerItems, groupKey) => {
        // 각 그룹의 첫 번째 아이템으로 그룹 헤더 정보 추출
        const firstItem = ledgerItems[0];
        const equipNm = firstItem.equipNm || '';
        const erCd = firstItem.erCd || '';

        // 유효한 하위 행(구분이 있는 행) 필터링
        const validSubItems = ledgerItems.filter((ledgerItem) => {
          const isIn = ledgerItem.inQty > 0;
          const isOut = ledgerItem.outQty > 0;
          return isIn || isOut;
        });

        // 하위 행이 있는지 확인
        const hasSubRows = validSubItems.length > 0;

        // 그룹 헤더 행 생성 (camelCase)
        const groupRow = {
          no: Date.now() + Math.random(),
          // camelCase 필드명 사용
          erCd: erCd,
          equipNm: equipNm,
          spec: firstItem.spec || '',
          price: firstItem.price || 0,
          unit: firstItem.unit || '',
          paymentStandard: firstItem.paymentStandard || '',
          managerDepartment: firstItem.managerDepartment || '',
          managerId: firstItem.managerId || '',
          depNmLast: firstItem.depNmLast || '',
          managerName: firstItem.managerName || '',
          remark: firstItem.remark || '',
          // 그리드 메타데이터
          group: equipNm,
          isGroupRow: true,
          // 데이터가 없으면 닫힌 상태(false), 있으면 펼쳐진 상태(true)
          isExpanded: hasSubRows,
          // 하위 행이 없으면 그룹 헤더 옆에 버튼 표시
          showAddSubButton: !!equipNm && !hasSubRows,
          newYn: 'N',
        };

        groupedData.push(groupRow);

        // 관리대장 이동 내역을 하위 행으로 추가 (구분이 있을 때만)
        validSubItems.forEach((ledgerItem, index) => {
          const isIn = ledgerItem.inQty > 0;
          const isOut = ledgerItem.outQty > 0;
          const gubun = isIn ? '입고' : '출고';

          // 마지막 하위 행인지 확인
          const isLastSubRow = index === validSubItems.length - 1;

          const subRow = {
            ...ledgerItem, // 원본 데이터 그대로 복사 (camelCase)
            no: Date.now() + Math.random() + 2000000,
            // 그리드 메타데이터 추가
            group: '',
            groupErCd: erCd,
            gubun: gubun,
            inDate: isIn ? ledgerItem.moveDate : null,
            outDate: isOut ? ledgerItem.moveDate : null,
            isGroupRow: false,
            isExpanded: true,
            showAddSubButton: false,
            newYn: 'N',
            // 마지막 하위 행 표시 (컬럼 정의에서 '+내역추가' 버튼 표시용)
            isLastSubRow: isLastSubRow,
          };
          groupedData.push(subRow);
        });
      });

      setOriginalRowData1(groupedData);
      const filteredData = filterExpandedRows(groupedData);
      setRowData1(filteredData);
      setExcelData(filteredData);

      // 조회 완료 후 플래그 해제
      isSearchingRef.current = false;
    },
  });

  // 그리드 조회 함수 (기존 호환성 유지)
  const SearchLogic1 = async (_value1) => {
    // 무한 루프 방지
    if (isSearchingRef.current) {
      return;
    }
    isSearchingRef.current = true;
    ResetLogic1();
    // 관리대장 데이터 조회 (getPpeBasic02R1)
    try {
      await Search1();
      isSearchingRef.current = false;
    } catch (error) {
      isSearchingRef.current = false;
    }
  };
  //#endregion
  //#region 저장
  // QUERY: 저장 훅
  const { runAsync: Save1Async } = useSave1({
    onSuccess: (response) => {
      dispatch(
        showSnackbar({
          message: '저장이 완료되었습니다.',
          type: 'success',
        })
      );
      // 저장 후 변경 목록 리셋 (저장된 행이 계속 신규로 인식되지 않도록)
      setChangedRowData1([]);
      // 저장 후 조회
      SearchLogic1();
    },
    onError: (error) => {
      dispatch(
        showSnackbar({
          message: error.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    },
  });

  const SaveLogic1 = async () => {
    // newYn === 'Y'인 행만 필터링 (새로 추가된 행)
    const rowsToSave = changedRowData1.filter((row) => row.newYn === 'Y');

    if (rowsToSave.length === 0) {
      dispatch(
        showSnackbar({
          message: '저장할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // 유효성 검사
    for (const row of rowsToSave) {
      
      const moveDate = row.moveDate || (row.gubun === '입고' ? row.inDate : row.outDate);
      if (!moveDate) {
        const dateLabel = row.gubun === '입고' ? '입고일자' : '출고일자';
        dispatch(showSnackbar({ message: `${dateLabel}를 입력해주세요.`, type: 'error' }));
        return;
      }

      const qty = row.gubun === '입고' ? Number(row.inQty) : Number(row.outQty);
      if (isNaN(qty) || qty <= 0) {
        const qtyLabel = row.gubun === '입고' ? '입고수량' : '출고수량';
        dispatch(showSnackbar({ message: `${qtyLabel}를 입력해주세요.`, type: 'error' }));
        return;
      }
    }

    // 저장할 데이터 변환
    const saveData = rowsToSave.map((row) => {
      // 수량을 숫자로 확실히 변환
      let inQty = row.inQty;
      let outQty = row.outQty;
      
      if (inQty === null || inQty === undefined || inQty === '') {
        inQty = 0;
      } else {
        inQty = Number(inQty);
        if (isNaN(inQty)) inQty = 0;
      }
      
      if (outQty === null || outQty === undefined || outQty === '') {
        outQty = 0;
      } else {
        outQty = Number(outQty);
        if (isNaN(outQty)) outQty = 0;
      }
      
      return {
        ...row,
        inQty: inQty,
        outQty: outQty,
        // moveDate 설정 (inDate 또는 outDate 우선)
        moveDate: row.inDate || row.outDate || row.moveDate,
      };
    });

    try {
      await Save1Async(saveData, {
        userInfo: userInfo,
      });
    } catch (error) {
      // 에러는 onError에서 처리
    }
  };
  //#endregion

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async (_value1) => {
    dispatch(showLoading());
    try {
      await SearchPhoto(userInfo.sign);

      // 그룹 행 제외하고 실제 데이터 행만 필터링
      const tableData = originalRowData1
        .filter((row) => !row.isGroupRow)
        .map((row, index) => {
          // 부서명 (camelCase 필드명 사용) - 명을 우선 사용
          const depName = row.depNmLast || row.managerDepartment || '';

          // 담당자명 (camelCase 필드명 사용) - 명을 우선 사용
          const memberName = row.managerName || row.managerId || '';

          // 날짜 형식 변환 (camelCase 필드명 사용)
          const inDate = row.inDate || (row.gubun === '입고' ? row.moveDate : null);
          const outDate = row.outDate || (row.gubun === '출고' ? row.moveDate : null);
          
          const inDateStr = inDate ? dayjs(inDate).format('YYYY-MM-DD') : '';
          const outDateStr = outDate ? dayjs(outDate).format('YYYY-MM-DD') : '';

          // 레포트 양식에 맞게 데이터 매핑 (영문 필드명 사용)
          // 천단위 구분 기호 추가 함수
          const formatNumber = (value) => {
            if (value == null || value === '') return '0';
            const num = typeof value === 'number' ? value : Number(value);
            return isNaN(num) ? '0' : num.toLocaleString('ko-KR');
          };

          return {
            NO: index + 1,
            EQUIP_NM: row.equipNm || '',
            UNIT: row.unit || '',
            SPEC: row.spec || '',
            PAYMENT_STANDARD: row.paymentStandard || '',
            PRICE: formatNumber(row.price),
            IN_DATE: inDateStr,
            IN_QTY: formatNumber(row.inQty),
            OUT_DATE: outDateStr,
            OUT_QTY: formatNumber(row.outQty),
            CURR_QTY: formatNumber(row.currentQty),
            MANAGER_DEPARTMENT: depName,
            MANAGER_ID: memberName,
            REMARK: row.remark || '',
          };
        });

      // 검색 연월 추출 (currentYear, currentMonth 사용)
      const currentYear = searchInfo.year;
      const currentMonth = searchInfo.month;
      let year = '';
      let month = '';

      if (currentYear && currentMonth) {
        year = currentYear.toString();
        month = currentMonth.toString();
      } else {
        // 날짜가 없으면 현재 년월 사용
        const now = new Date();
        year = now.getFullYear().toString();
        month = String(now.getMonth() + 1).padStart(2, '0');
      }

      const printData = {
        FileName: 'PPE_BASIC_04',
        HeaderData: JSON.stringify({
          YEAR: year,
          MONTH: month,
          CUST_NM:
            searchInfo.custList.filter((e) => e.value === searchInfo.custCd)[0]
              ?.name || '',
          USER_NM: userInfo.userNm || '',
          USER_SIGN: !imgRef.current
            ? ''
            : imgRef.current.replace(/^data:image\/[a-z]+;base64,/, ''),
        }),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  //엑셀다운로드 버튼 클릭 시
  const ExcelDownload = async () => {
    setReadyToExport(true);
  };
  //사진 가져오기
  const SearchPhoto = async (_path) => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(_path),
        }
      ).then((result) => {
        let data = result.data;
        if (data !== 'Error') {
          imgRef.current = `data:image/png;base64,${data}`;
        }
      });
    } catch (e) {
      // 에러 처리
    } finally {
    }
  };

  // 상태값 리셋
  const ResetLogic1 = () => {
    setOriginalRowData1([]);
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setExcelData([
      {
        EQUIP_NM: '보호구명',
        EQUIP_USE: '용도',
        IN_QTY: 0,
        STOCK_QTY: 0,
        USE_QTY: 0,
        CURR_QTY: 0,
        REMARK: '비고',
      },
    ]);
  };


  // 그룹 접기/펼치기 핸들러
  const handleToggleGroup = (groupRow) => {
    const currentOriginalData = [...originalRowData1];
    const groupRowIndex = currentOriginalData.findIndex(
      (row) => row.no === groupRow.no
    );

    if (groupRowIndex === -1) return;

    // isExpanded 상태 토글
    const updatedGroupRow = {
      ...currentOriginalData[groupRowIndex],
      isExpanded: !currentOriginalData[groupRowIndex].isExpanded,
    };

    currentOriginalData[groupRowIndex] = updatedGroupRow;
    setOriginalRowData1(currentOriginalData);

    // 필터링된 데이터 업데이트
    const filteredData = filterExpandedRows(currentOriginalData);
    setRowData1(filteredData);
  };

  // + 새하위항목 버튼 클릭 핸들러
  const handleAddSubItem = (groupRow) => {
    const currentOriginalData = [...originalRowData1];
    const groupRowIndex = currentOriginalData.findIndex(
      (row) => row.no === groupRow.no
    );

    if (groupRowIndex === -1) return;

    // 그룹이 닫혀있는 경우 먼저 펼치기
    const currentGroupRow = currentOriginalData[groupRowIndex];
    if (currentGroupRow.isExpanded === false) {
      currentOriginalData[groupRowIndex] = {
        ...currentGroupRow,
        isExpanded: true,
      };
      setOriginalRowData1(currentOriginalData);
      // 필터링된 데이터 업데이트 (그룹 펼치기)
      const filteredData = filterExpandedRows(currentOriginalData);
      setRowData1(filteredData);
    }

    // 그룹 행 다음에 하위 행 추가 (camelCase 필드명 사용)
    const newSubRow = {
      no: Date.now() + Math.random() + 1000000,
      // camelCase 필드명 사용
      erCd: groupRow.erCd || '',
      equipNm: groupRow.equipNm || '',
      spec: groupRow.spec || '',
      price: groupRow.price || 0,
      unit: groupRow.unit || '',
      paymentStandard: groupRow.paymentStandard || '',
      managerDepartment: groupRow.managerDepartment || '',
      managerId: groupRow.managerId || '',
      depNmLast: groupRow.depNmLast || '',
      managerName: groupRow.managerName || '',
      remark: groupRow.remark || '',
      moveDate: null,
      inQty: null,
      outQty: null,
      currentQty: null,
      reason: '',
      // 그리드 메타데이터
      group: '',
      groupErCd: groupRow.erCd || '',
      gubun: '입고',
      inDate: null,
      outDate: null,
      isGroupRow: false,
      isExpanded: true,
      showAddSubButton: false,
      newYn: 'Y',
    };

    // 그룹 행 다음에 하위 행 삽입
    // 같은 그룹의 마지막 하위 행 다음에 삽입
    const groupErCd = groupRow.erCd || '';
    let insertIndex = groupRowIndex + 1;
    
    // 같은 그룹의 마지막 하위 행 찾기
    let lastSubRowIndex = -1;
    while (
      insertIndex < currentOriginalData.length &&
      !currentOriginalData[insertIndex].isGroupRow &&
      currentOriginalData[insertIndex].groupErCd === groupErCd
    ) {
      // 마지막 하위 행 추적
      if (currentOriginalData[insertIndex].isLastSubRow) {
        lastSubRowIndex = insertIndex;
      }
      insertIndex++;
    }

    // 기존 마지막 하위 행의 isLastSubRow 플래그 제거
    if (lastSubRowIndex !== -1) {
      currentOriginalData[lastSubRowIndex] = {
        ...currentOriginalData[lastSubRowIndex],
        isLastSubRow: false,
      };
    }

    // 새 행에 isLastSubRow 플래그 설정
    newSubRow.isLastSubRow = true;

    currentOriginalData.splice(insertIndex, 0, newSubRow);
    setOriginalRowData1(currentOriginalData);

    // 필터링된 데이터 업데이트
    const filteredData = filterExpandedRows(currentOriginalData);
    setRowData1(filteredData);

    setChangedRowData1((prev) => [...prev, newSubRow]);
  };
  //#endregion

  return (
    <PPE_BASIC_02
      value={props.value}
      userInfo={userInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      originalRowData1={originalRowData1}
      setOriginalRowData1={setOriginalRowData1}
      filterExpandedRows={filterExpandedRows}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      filterClick2={props.filterClick2}
      setFilterClick2={props.setFilterClick2}
      searchClick2={props.searchClick2}
      setSearchClick2={props.setSearchClick2}
      addClick2={props.addClick2}
      setAddClick2={props.setAddClick2}
      saveClick2={props.saveClick2}
      setSaveClick2={props.setSaveClick2}
      printClick2={props.printClick2}
      setPrintClick2={props.setPrintClick2}
      excelData={excelData}
      setExcelData={setExcelData}
      readyToExport={readyToExport}
      setReadyToExport={setReadyToExport}
      fileInputRef={fileInputRef}
      gridRef1={gridRef1}
      gridRef2={gridRef2}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={SearchLogic1}
      SaveLogic1={SaveLogic1}
      PrintLogic1={PrintLogic1}
      ExcelDownload={ExcelDownload}
      SearchPhoto={SearchPhoto}
      handleAddSubItem={handleAddSubItem}
      handleToggleGroup={handleToggleGroup}
    />
  );
}

export default PPE_BASIC_02F;
